// src/lib/profileAudit.js
import { supabase } from "../../supabaseClient";

function cleanText(value, maxLength = 500) {
  return String(value ?? "").trim().slice(0, maxLength);
}

function cleanObject(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return {};
  }

  return value;
}

export async function recordProfileAuditEvent({
  eventType,
  entityType = "user_profile",
  entityTable = null,
  entityId = null,
  changedFields = [],
  beforeValues = {},
  afterValues = {},
  metadata = {},
}) {
  const { data, error: userError } = await supabase.auth.getUser();

  if (userError) throw userError;

  const user = data?.user;

  if (!user?.id) {
    throw new Error("Not authenticated.");
  }

  const cleanChangedFields = Array.isArray(changedFields)
    ? changedFields.map((field) => cleanText(field, 80)).filter(Boolean)
    : [];

  const { error } = await supabase.from("profile_audit_events").insert({
    user_id: user.id,
    actor_user_id: user.id,
    event_source: "profile_page",
    event_type: cleanText(eventType, 100),
    entity_type: cleanText(entityType, 100),
    entity_table: entityTable ? cleanText(entityTable, 150) : null,
    entity_id: entityId ? cleanText(entityId, 150) : null,
    changed_fields: cleanChangedFields,
    before_values: cleanObject(beforeValues),
    after_values: cleanObject(afterValues),
    metadata: {
      ...cleanObject(metadata),
      app_path:
        typeof window !== "undefined" ? window.location.pathname : null,
      user_agent:
        typeof navigator !== "undefined" ? navigator.userAgent : null,
    },
  });

  if (error) throw error;

  return true;
}